// PSApiClient.js
const BASE_URL = "/ps";
const UPLOAD_BASE_URL = "/uploads";
const REQUEST_TIMEOUT_MS = 15000;

function getToken() {
  return localStorage.getItem("accessToken");
}

// FIX: previously a hung server-side middleware (never calling next() and
// never sending a response) meant fetch() would wait forever — button stuck
// on "Creating…", nothing saved, and no error ever shown. Every request now
// aborts after 15s and surfaces a clear, specific error instead.
async function withTimeout(fetchPromise) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    return await fetchPromise(controller.signal);
  } catch (e) {
    if (e.name === "AbortError") {
      const err = new Error("The server didn't respond in time. Please try again.");
      err.status = 0;
      err.isTimeout = true;
      throw err;
    }
    throw e;
  } finally {
    clearTimeout(timer);
  }
}

async function request(path, options = {}) {
  const res = await withTimeout((signal) =>
    fetch(`${BASE_URL}${path}`, {
      ...options,
      signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
        ...(options.headers || {}),
      },
    })
  );

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || `Request failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

export const psGet = (path) => request(path, { method: "GET" });
export const psPost = (path, data) =>
  request(path, { method: "POST", body: JSON.stringify(data) });
export const psPut = (path, data) =>
  request(path, { method: "PUT", body: JSON.stringify(data) });

export async function psUpload(uploadUrl, file, extraHeaders = {}) {
  const body = new FormData();
  body.append("file", file);

  const res = await withTimeout((signal) =>
    fetch(`${UPLOAD_BASE_URL}${uploadUrl}`, {
      method: "POST",
      signal,
      headers: { Authorization: `Bearer ${getToken()}`, ...extraHeaders },
      body,
    })
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.status === false || data.success === false) {
    const err = new Error(data.message || `Upload failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}
